import { render, staticRenderFns } from "./UplimitStepOnPlate.vue?vue&type=template&id=788d7f5f&scoped=true"
import script from "./UplimitStepOnPlate.vue?vue&type=script&lang=js"
export * from "./UplimitStepOnPlate.vue?vue&type=script&lang=js"
import style0 from "./UplimitStepOnPlate.vue?vue&type=style&index=0&id=788d7f5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788d7f5f",
  null
  
)

export default component.exports